import { copy } from '~/_shared/utils/collections/collections';
import type { StatsAction } from './stats.action';
import {
  addBoundaryStatsItems, updateBoundaryStatsItems,
} from './stats.actionCreators';
import {
  createEmptyBoundaryStatItemDemographic, createEmptyBoundaryStatItemSpreadsheetColumn,
} from './stats.factory';
import {
  findBoundaryGroupStatItemDemographic, findBoundaryGroupStatItemSpreadsheetColumn, isBoundaryStatItemDemographicMetricData, isBoundaryStatItemSpreadsheetColumnMetricData,
} from './stats.helpers';
import type { StatsState } from './stats.state';

const initialState: StatsState = {
  boundaryGroupStats: new Map(),
};

export const statsReducer = (
  state = initialState,
  action: StatsAction
): StatsState => {
  if (addBoundaryStatsItems.match(action)) {

    return action.payload.newItems.reduce((newState, item) => {
      let newItem = null;

      if (isBoundaryStatItemSpreadsheetColumnMetricData(item)) {
        const existing = findBoundaryGroupStatItemSpreadsheetColumn(newState.boundaryGroupStats, item);
        if (!existing) {
          newItem = createEmptyBoundaryStatItemSpreadsheetColumn(item);
        }
      }

      if (isBoundaryStatItemDemographicMetricData(item)) {
        const existing = findBoundaryGroupStatItemDemographic(newState.boundaryGroupStats, item);
        if (!existing) {
          newItem = createEmptyBoundaryStatItemDemographic(item);
        }
      }

      if (newItem) {
        const newStatsItemForBoundaryGroup = copy.andReplace(
          newState.boundaryGroupStats.get(newItem.boundaryGroupId) || new Map(),
          newItem.id,
          newItem
        );

        return {
          ...newState,
          boundaryGroupStats: new Map(state.boundaryGroupStats).set(
            newItem.boundaryGroupId,
            newStatsItemForBoundaryGroup
          ),
        };
      }
      return state;

    }, state);
  }

  if (updateBoundaryStatsItems.match(action)) {
    return action.payload.items.reduce((newState, item) => {
      const currentBoundaryGroupStats = newState.boundaryGroupStats.get(item.boundaryGroupId);
      const currentItemById = currentBoundaryGroupStats?.get(item.id);

      if (currentBoundaryGroupStats && currentItemById) {
        const updatedBoundaryGroupStats = copy.andReplace(
          currentBoundaryGroupStats,
          item.id,
          item,
        );

        return {
          ...newState,
          boundaryGroupStats: new Map(newState.boundaryGroupStats).set(
            item.boundaryGroupId,
            updatedBoundaryGroupStats
          ),
        };
      }

      return newState;
    }, state);
  }

  return state;
};
